import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import {
    Checkbox,
    Container,
    Dialog,
    DialogContent,
    DialogTitle,
    LinearProgress,
    Link,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Typography
} from '@mui/material';
import { BatchPrintingStyles } from 'customStyles';
import React, { useCallback, useEffect, useState } from 'react';
import { useTableStore } from 'state/TableStore';
import { urls } from "../../../urls";
import { PrintModalHeaderCells, createSortHandler, defineDataTestid, defineModalTitle, getVisibleRows, isSelected } from '../helpers';
import { batchPrintStepsObject, getPdfUrl } from '../utils/helpers';
import BatchPrintingModalAction from "./fragments/BatchPrintingModalActions"
import BatchPrintingExceptionsMessage from "./fragments/BatchPrintingExceptionsMessage";

export const EXPIRATION_TIME_PDF = (10 * 60_000)

export const PrintModal: React.FC<any> = ({ label, rows, handleClose, open, handleOpenPrint }) => {
    const pagination = useTableStore(state => state.pagination)
    const { order, orderBy } = pagination
    const url = urls.BATCHPRINT;
    const [tcnResp, setResp] = useState<any>({})
    const [pdfAvailable, setPdfAvailable] = useState(false)
    const [presignedS3Url, setPreSignedUrl] = useState("")
    const [percentComplete, setPercentComplete] = useState(0)
    const [numJobStatusCalls,] = React.useState(0)
    const [remaining, setRemaining] = useState<any>(EXPIRATION_TIME_PDF);
    const [activeTimer, setActiveTimer] = useState<boolean>(false)
    const [hoverLabel, setHoverLabel] = useState("")
    const tcns = useTableStore(state => state.tcns)
    const setTcns = useTableStore(state => state.setTcns)
    const selected = useTableStore(state => state.selected)
    const setSelected = useTableStore(state => state.setSelected)
    const [page,] = React.useState(0);
    const [rowsPerPage,] = React.useState(5);
    const [batchPrintSteps, setBatchPrintSteps] = useState(batchPrintStepsObject);

    let jobStatusController = new AbortController()
    let checkPdfController = new AbortController()

    const checkUrlTimeout = React.useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        console.log('batch print confirm tcns PrintModal ', tcns)
        let selected: any = []
        tcns.forEach((record: any) => selected.push(record.transactionNumber))
        console.log('batch print flow set selected: ', selected)
        setSelected(selected)
    }, [tcns, setSelected])

    console.log('batch print flow printModal rows:  ', JSON.stringify(rows))
    console.log('printModal tcns', tcns)

    const visibleRows = React.useMemo(
        () => getVisibleRows(page, tcns.length, tcns, pagination),
        [tcns, page, pagination]
    );

    const handleInitiateCancel = () => {
        setBatchPrintSteps({
            ...batchPrintStepsObject,
            stepA_Confirm: false,
            cancelConfirmPrint: !batchPrintSteps.pdfGenError,
            cancelConfirmError: batchPrintSteps.pdfGenError
        });
    }

    const handleConfirmCancel = () => {
        jobStatusController.abort();
        checkPdfController.abort();

        if (checkUrlTimeout.current) {
            clearTimeout(checkUrlTimeout.current);
        }

        setPdfAvailable(false);

        handleClose();
    }

    const handleResumeFlow = () => {
        setBatchPrintSteps(prev => {
            // If the PDF became available in the background while the cancellation was pending,
            // jump to the Document Ready step.
            if (pdfAvailable) {
                return {
                    ...prev,
                    cancelConfirmPrint: false,
                    cancelConfirmError: false,
                    stepB_PreparePdf: false,
                    stepC_DocumentReady: true,
                    confirmingPrintJobs: false,
                }
            }

            // Otherwise, hide the dialog and go back to the loading step.
            return {
                ...prev,
                cancelConfirmPrint: false,
                cancelConfirmError: false,
                stepB_PreparePdf: true,
            }
        });
    }

    const handleClearCancel = () => {
        setTcns([]);
        setResp({});
        handleClose();
    }

    //Delete tcn from tcns when deselecting from confirm screen. 
    const getPrintJobStatus = useCallback(async (numCalls = 0) => {
        let timeoutGetPdfUrl;
        let timeoutGetPrintJobStatus;
        console.log('batch print flow tcnResp.batchPrintJob', tcnResp.batchPrintJob)
        console.log('batch print flow tcnResp.batchPrintJob?.replace("Final.pdf", ""): ', tcnResp.batchPrintJob?.replace("/Final.pdf", ""))
        console.log(`batch print flow getPrintJobStatus numCalls ${numCalls}`)
        let numJobStatusCalls = numCalls + 1;
        let maxCalls = tcns.length * 10 //Num of jobs selected * some number of max calls per item
        console.log('batch print flow num of transanactions: ', tcns.length)
        console.log('batch print flow maxCalls: ', maxCalls)

        let resp: any;
        try {
            resp = await (fetch(`${process.env.NODE_ENV === "production" ? url : ""
                }/batchprint/job-status/${tcnResp.batchPrintJob?.replace("/Final.pdf", "")}`, {
                method: 'GET',
                credentials: 'include',
                signal: jobStatusController.signal
            }))

            console.log('batch print flow getPrintJobStatus resp: ', resp);

            if (resp.ok) {
                const message = await resp.json()
                console.log('batch print flow getPrintJobStatus percent complete: ', parseInt(message.result.pct))
                if (parseInt(message.result.pct) === 100) {
                    console.log('batch print flow getPrintJobStatus message.result: ', message.result)
                    timeoutGetPdfUrl = setTimeout(() => {
                        getPdfUrl(tcnResp, checkUrl);
                    }, 2000)
                } else if (parseInt(message.result.pct) < 100) {
                    setPercentComplete(parseInt(message.result.pct))
                    console.log(`batch print flow getPrintJobStatus percent complete ${parseInt(message.result.pct)} calling getPrintJobStatus`)
                    timeoutGetPrintJobStatus = setTimeout(() => {
                        console.log('batch print flow getPrintJobStatus called')
                        getPrintJobStatus(numJobStatusCalls)
                    }, 3000)
                } else {
                    console.error('batch print flow Error retrieving job status')
                    jobStatusController.abort()
                    checkPdfController.abort()
                    setBatchPrintSteps({
                        ...batchPrintStepsObject,
                        stepA_Confirm: false,
                        pdfGenError: true,
                    });
                    handleClearCancel();

                    return
                }
            } else {
                console.error('batch print flow Error retrieving job status')
                jobStatusController.abort()
                checkPdfController.abort()
                setBatchPrintSteps({
                    ...batchPrintStepsObject,
                    stepA_Confirm: false,
                    pdfGenError: true,
                })
                handleClearCancel();
                return
            }

        } catch (e: any) {
            if (numJobStatusCalls <= maxCalls && (!resp || (resp && resp.status === 400))) {
                setTimeout(() => {
                    getPrintJobStatus(numJobStatusCalls)
                }, 5000);
            } else {
                console.error('Error submmiting tcns: ', e)
                console.log('job-status catch block getPrintJobStatus called')
            }
        }

        return () => {
            clearTimeout(timeoutGetPdfUrl);
            clearTimeout(timeoutGetPrintJobStatus);
        }
    }, [tcnResp.batchPrintJob])

    useEffect(() => {
        if ((batchPrintSteps.stepB_PreparePdf || batchPrintSteps.cancelConfirmPrint) && tcnResp.batchPrintJob && numJobStatusCalls <= 2) {
            console.log('batch print flow useEffect tcnResp.batchPrintJob: ', tcnResp.batchPrintJob)
            setTimeout(() => {
                getPrintJobStatus()
            }, 5000)
        }

    }, [batchPrintSteps.stepB_PreparePdf, tcnResp.batchPrintJob])

    const checkUrl = async (presignedUrl: string) => {
        let resp = await fetch(presignedUrl, {
            signal: checkPdfController.signal
        });

        if (resp.status === 200) {
            setPercentComplete(100);
            checkUrlTimeout.current = setTimeout(() => {
                setPdfAvailable(true);
                setPreSignedUrl(presignedUrl);
            }, 1500);
        } else {
            checkUrl(presignedUrl);
        }
    }

    useEffect(() => {
        if (pdfAvailable && !batchPrintSteps.cancelConfirmPrint && !batchPrintSteps.cancelConfirmError) {
            setBatchPrintSteps((prevSteps: any) => {
                return {
                    ...prevSteps,
                    stepB_PreparePdf: false,
                    stepC_DocumentReady: true,
                    pdfGenError: false,
                    confirmingPrintJobs: false
                }
            });
            window.open(presignedS3Url, '_blank');
        }
    }, [pdfAvailable, rows, tcns, batchPrintSteps.cancelConfirmPrint, batchPrintSteps.cancelConfirmError])

    const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log('batch printing select all')
        if (event.target.checked && rows) {
            const newSelected = tcns.map((row: any) => row.transactionNumber);
            console.log('batch print flow set selected: ', newSelected)
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    }

    const handleClick = (event: React.MouseEvent<unknown>, id: string) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected: string[] = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        console.log('batch print flow set selected: ', newSelected)
        setSelected(newSelected);
    };

    useEffect(() => {
        console.log('batch print confirm selected: ', selected)
    }, [selected.length])

    const formatCountdownFriendly = (remainInMs: number) => {
        const remainInSecond = Math.round(remainInMs / 1000);
        const mins = Math.floor(remainInSecond / 60);
        const secs = remainInSecond % 60;
        const formatTime = `${String(mins)}:${String(secs).padStart(2, '0')} ${mins === 0 ? 'seconds' : 'minutes'}`;
        return formatTime;
    };

    useEffect(() => {
        if (batchPrintSteps.stepC_DocumentReady) setActiveTimer(true)
    }, [batchPrintSteps.stepC_DocumentReady])

    useEffect(() => {
        if (activeTimer) {
            const interval = setInterval(() => {
                console.log('batch print flow remaining: ', remaining)
                if (remaining > 0) {
                    setRemaining((prevTime) => prevTime - 1000)
                } else {
                    setBatchPrintSteps({
                        ...batchPrintStepsObject,
                        stepA_Confirm: false,
                        docExpired: true,
                    })
                    clearInterval(interval)
                }
            }, 1000);

            if (batchPrintSteps.stepD_Confirm) {
                clearInterval(interval)
            }

            return () => {
                clearInterval(interval);
            };
        }
    }, [activeTimer, remaining, batchPrintSteps.stepD_Confirm]);

    return (
        <Dialog onClose={handleClose} open={open} fullWidth={true}
            PaperProps={{
                style: {
                    minWidth: batchPrintSteps.stepD_Confirm ? "80vw" : "600px",
                    minHeight: batchPrintSteps.stepC_DocumentReady ? "329px" :
                        batchPrintSteps.stepD_Confirm ? "831px" : "221px"
                }
            }}
            data-testid={defineDataTestid(batchPrintSteps)}
        >
            <Paper sx={{
                overflowY: 'hidden',
                minWidth: batchPrintSteps.stepD_Confirm ? "80vw" : "600px",
                minHeight: batchPrintSteps.stepC_DocumentReady ? "329px" :
                    batchPrintSteps.stepD_Confirm ? "831px" : "221px",
                backgroundColor: 'background.default'
            }}
            >
                <DialogTitle>{defineModalTitle(batchPrintSteps)}</DialogTitle>
                <DialogContent sx={{
                    ...BatchPrintingStyles.printModalContent,
                    justifyContent: batchPrintSteps.stepD_Confirm ? "flex-start" : "space-evenly",
                    width: batchPrintSteps.stepD_Confirm ? "100%" : "600px",
                    minHeight: batchPrintSteps.stepC_DocumentReady ? "214px" :
                        batchPrintSteps.stepD_Confirm ? "684px" : "92px",
                }}
                >
                    {
                        batchPrintSteps.stepB_PreparePdf && (
                            <Container disableGutters sx={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-evenly" }}>
                                <LinearProgress
                                    variant={percentComplete === 0 ? "indeterminate" : "determinate"}
                                    value={percentComplete}
                                    sx={{ width: "95%", marginRight: "8px" }}
                                />
                                <Typography>{percentComplete}%</Typography>
                            </Container>
                        )
                    }
                    {
                        batchPrintSteps.stepA_Confirm && (
                            <Typography variant="body1">
                                You have selected <span style={{ width: "max-content", fontWeight: 500 }}>({tcns.length}) {tcns.length > 1 ? "transactions" : "transaction"} </span>to print. Select 'Continue' to compile all transactions into a PDF document that will be printed from a new tab.
                            </Typography>
                        )
                    }
                    {
                        batchPrintSteps.stepB_PreparePdf && (
                            <Typography variant="body1">
                                Please wait while your PDF  document is prepared. When the document is ready, it will automatically open in a new tab
                            </Typography>
                        )
                    }
                    {
                        batchPrintSteps.stepC_DocumentReady && (
                            <>
                                <LinearProgress variant="determinate" value={100} sx={{ width: "100%" }} />
                                <Typography variant="body1">
                                    Please navigate to the tab containing your PDF document. When you have finished printing, return to this screen and select 'continue'.
                                    If an error occurs while printing, or you wish to return all transactions to the batch pool, select the 'cancel' button.
                                    The PDF document will expire in <b>{formatCountdownFriendly(remaining)}</b>.
                                </Typography>
                                <Link target="_blank" href={presignedS3Url} rel="noopener">PDF document</Link>
                            </>

                        )
                    }
                    {
                        batchPrintSteps.stepD_Confirm && (
                            <Typography sx={{ minWidth: "100%" }} variant="body1">
                                Please check and confirm all printing was successful. Uncheck any printing jobs that were not successful. Unchecked documents will be returned to the batch print pool.
                                Confirmed print jobs will be removed from the batch pool. For a history of completed print jobs or to reprint already printed job, visit applicant profile history.
                            </Typography>
                        )
                    }
                    {
                        (batchPrintSteps.cancelConfirmPrint || batchPrintSteps.cancelConfirmError) && (
                            <Typography sx={{ maxWidth: "600px" }} variant="body1">
                                Cancelling this transaction will return all selected transaction(s) back to the batch pool.
                            </Typography>
                        )
                    }
                    {
                        batchPrintSteps.stepD_Confirm && (
                            <TableContainer sx={BatchPrintingStyles.printModalTableContainer} component={Paper}>
                                <Table sx={BatchPrintingStyles.printModalTable} stickyHeader aria-label={label}>
                                    <TableHead>
                                        <TableRow>
                                            {
                                                PrintModalHeaderCells.map((cell: any, index: number) => {
                                                    return (
                                                        <TableCell
                                                            sx={BatchPrintingStyles.tableHeadCellStyle}
                                                            key={cell.label}
                                                            align={'left'}
                                                            padding={cell.disablePadding ? 'none' : 'normal'}
                                                            sortDirection={orderBy === cell.dataIndex ? order : false}>

                                                            <TableSortLabel
                                                                hideSortIcon={cell.dataIndex === hoverLabel ? false : true}
                                                                onMouseEnter={() => setHoverLabel(cell.dataIndex)}
                                                                onMouseLeave={() => setHoverLabel("")}
                                                                active={orderBy === cell.dataIndex}
                                                                direction={orderBy === cell.dataIndex ? order : 'asc'}
                                                                onClick={createSortHandler(cell.dataIndex)}
                                                                IconComponent={(iconE: any) => (
                                                                    (label === 'agency-management' || label == "rapback-summary" || label === "print-confirmation" || label === "batch-printing" || label === "transaction-summary")
                                                                        && cell.dataIndex !== 'actions' && cell.dataIndex !== 'checkbox'
                                                                        ? (order === 'asc' && orderBy === cell.dataIndex)
                                                                            ? <ArrowUpwardIcon sx={{ marginRight: 2, height: "20px", width: "20px", color: 'text.secondary' }} />
                                                                            : <ArrowDownwardIcon sx={{ marginRight: 2, height: "20px", width: "20px", color: 'text.secondary' }} />
                                                                        : null
                                                                )}
                                                                sx={BatchPrintingStyles.printModaltableSortLabel}
                                                                color='text.primary'>
                                                                {
                                                                    // select all button 
                                                                    cell.label === "Full Name"
                                                                        ? <Checkbox
                                                                            checked={tcns.length > 0 && selected.length === tcns.length}
                                                                            onChange={handleSelectAll} aria-label="select all" />
                                                                        : null
                                                                }

                                                                <Typography sx={BatchPrintingStyles.printModalCellLabel}>
                                                                    {cell.label}
                                                                </Typography>
                                                            </TableSortLabel>
                                                        </TableCell>
                                                    )
                                                })
                                            }
                                        </TableRow>
                                    </TableHead>
                                    <TableBody sx={BatchPrintingStyles.printModalTableBody} >
                                        {
                                            visibleRows.map((row: any) => {
                                                const isItemSelected = isSelected(row.transactionNumber, selected)
                                                return (
                                                    <TableRow selected={isItemSelected} aria-checked={isItemSelected} onClick={(e) => {
                                                        handleClick(e, row.transactionNumber)
                                                    }} key={row.key}>
                                                        {
                                                            PrintModalHeaderCells.map((cell: any) => {
                                                                return (
                                                                    <TableCell key={cell.dataIndex + cell.id}
                                                                        sx={{
                                                                            ...BatchPrintingStyles.printmodalTableCell,
                                                                            display: cell.dataIndex === "fullName" ? "flex" : "table-cell",
                                                                        }}>
                                                                        {
                                                                            cell.dataIndex === "fullName" && (
                                                                                <Checkbox
                                                                                    color="primary"
                                                                                    checked={isItemSelected}   //Select all works need to fix individual select somehow
                                                                                    aria-label='checkbox fullname'
                                                                                    aria-checked={isItemSelected}
                                                                                />
                                                                            )
                                                                        }
                                                                        <Typography variant='body2'>{cell.dataIndex === "fullName" ? row.firstName + " " + row.lastName : row[cell.dataIndex]}</Typography>
                                                                    </TableCell>
                                                                )
                                                            })
                                                        }
                                                    </TableRow>
                                                )
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )
                    }
                    <BatchPrintingExceptionsMessage batchPrintSteps={batchPrintSteps} />
                </DialogContent>
                <BatchPrintingModalAction
                    batchPrintSteps={batchPrintSteps}
                    setBatchPrintSteps={setBatchPrintSteps}
                    handleClose={handleClose}
                    handleInitiateCancel={handleInitiateCancel}
                    handleConfirmCancel={handleConfirmCancel}
                    handleResumeFlow={handleResumeFlow}
                    tcns={tcns}
                    setResp={setResp}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    setPercentComplete={setPercentComplete}
                    setRemaining={setRemaining}
                    setPdfAvailable={setPdfAvailable}
                    handleOpenPrint={handleOpenPrint}
                />
            </Paper>
        </Dialog>
    )
}